import { createFileRoute } from "@tanstack/react-router";

import { AthletePageTabsLayout } from "src/pages/AthletePageTabsLayout";

export const Route = createFileRoute(
  "/_auth/_coach/orgs/$slug/athletes/$athleteId/_tabs",
)({
  component: AthletePageTabsLayout,
});
